import styled from "styled-components"

const TransferMessage = styled.div`
  position: absolute;
  top: 50%;
  margin-top: -18px;
  padding: 5px;
  text-align: center;
  width: 100%;
`

export default TransferMessage
